/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2023-02-02 16:55:12
 */

import React, { useState, useEffect } from 'react'
import { Modal, Button, Checkbox } from 'antd'
import desktopLib from '../../../../utils/desktopLib'
import { useAppDispatch, useAppSelector } from '../../../../app/hooks'
import { setDownloadSettingModalVisible } from '../../../../actions/main'

const DownloadSetting = () => {
  const [path, setPath] = useState('')
  const [openFolderWhenDone, setOpenFolderWhenDone] = useState(true)
  const isDesktop = desktopLib.isDesktop
  const visible = useAppSelector(
    (state) => state.main.downloadSettingModalVisible
  )
  const dispatch = useAppDispatch()

  const handleChoosePath = () => {
    if (isDesktop) {
      desktopLib.chooseDownloadPath().then((path) => {
        if (path) {
          setPath(path)
        }
      })
    }
  }

  const handleClose = () => {
    dispatch(setDownloadSettingModalVisible(false))
  }

  const handleChangePath = () => {
    if (isDesktop) {
      desktopLib
        .updateDownloadConfig({ path, openFolderWhenDone })
        .then((data) => {
          handleClose()
        })
    }
  }

  useEffect(() => {
    if (isDesktop && visible) {
      desktopLib.getDownloadConfig().then((config) => {
        setPath(config.path)
        setOpenFolderWhenDone(config.openFolderWhenDone)
      })
    }
  }, [visible])

  if (isDesktop) {
    return (
      <Modal
        title="下载保存位置"
        open={visible}
        centered
        onOk={handleChangePath}
        onCancel={handleClose}
      >
        <h3>默认下载位置</h3>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span
            style={{
              display: 'inline-block',
              width: 320,
              marginRight: 20,
              padding: 7,
              border: '1px solid #DEDEDE',
              borderRadius: '4px',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis'
            }}
          >
            {path}
          </span>
          <Button type="primary" ghost onClick={handleChoosePath}>
            浏览
          </Button>
        </div>
        <Checkbox
          style={{ marginTop: 20 }}
          checked={openFolderWhenDone}
          onChange={(e) => setOpenFolderWhenDone(e.target.checked)}
        >
          下载完成自动打开目录
        </Checkbox>
      </Modal>
    )
  }
  return null
}

export default DownloadSetting
